
import { Tooltip } from "@material-ui/core";
import { Linked } from "@type-r/models";
import { div, navigate, PrimaryButton, span } from "lqx-react";
import { Button } from "lqx-react/src";
import React from "react";
import { UserEntitlementCatalogs } from "src/app/models/UserEntitlements";
import { Can } from "src/app/services/can";
import { ImportJob } from "../api/importJob";
import { ImportJobStatusType } from "./models/ImportJobStatusType";
import { preventDefaultAndStopPropagation } from "../shared";

export const ImportJobActions = ({
    $doProcessJob,
    importJob
}: {
    $doProcessJob: Linked<{ jobId?: Number, needApproval?: boolean, actionType?: String, assetTypeId?: Number }>,
    importJob: ImportJob
}) => {
    const isProcessed = (statusId: any) => handleIsProcessed(statusId) === ImportJobStatusType.Processed
    const isProcessing = (statusId: any) => handleIsProcessed(statusId) === ImportJobStatusType.Processing;
    const isReProcessing = (statusId: any) => handleIsProcessed(statusId) === ImportJobStatusType.Reprocessing;
    const isClosed = (statusId: any) => handleIsProcessed(statusId) === ImportJobStatusType.Closed;
    const isErrorProcessing = (statusId: any) => handleIsProcessed(statusId) === ImportJobStatusType.ErrorProcessing;
    const isGreaterThan30Min = () => {
        const dateNow = new Date();
        // Calculate the time difference in milliseconds
        const timeDifferenceMilliseconds = dateNow.getTime() - importJob.initiatedOn.getTime();
        // Convert the time difference to minutes
        const timeDifferenceMinutes = timeDifferenceMilliseconds / (1000 * 60);
        // Check if time difference is greater than 30 minutes.
        return timeDifferenceMinutes > 30;

    }
    // const isReprocessing = () =>
    //     Boolean($doProcessJob.value.jobId) &&
    //     !Boolean($doProcessJob.value.needApproval) &&
    //     importJob.jobId == $doProcessJob.value.jobId &&
    //     $doProcessJob.value.actionType === "Reprocess";

    const showCloseButton = (statusId: any) => isProcessing(statusId) || isReProcessing(statusId);
    const canReprocess = (statusId: any) => (isErrorProcessing(statusId) || isProcessed(statusId) || ((isProcessing(statusId) || isReProcessing(statusId)) && isGreaterThan30Min())) && !importJob.isManual;

    const handleIsProcessed = (statusId) => {
        if (statusId) {
            return statusId.name
        }
        return statusId;
    }

    return <>
        <ButtonsBlock>
            {
                Can(UserEntitlementCatalogs.EditImportJobPage) &&
                isProcessed(importJob.statusId) &&
                <>
                    <Button onClick={() => navigate(`ingest/edit/${importJob.jobId}`)} color="primary">Edit</Button>
                    <Button onClick={() => navigate(`ingest/edit/${importJob.jobId}?activeStep=1`)} color="primary">View Digitized Assets</Button>
                </>
            }
            {
                Can(UserEntitlementCatalogs.CloseJobAssets) &&
                showCloseButton(importJob.statusId) &&
                <PrimaryButton onClick={(e) => {
                    preventDefaultAndStopPropagation(e);
                    $doProcessJob.set({
                        jobId: importJob.jobId,
                        needApproval: importJob.statusId.name === ImportJobStatusType.Processing,
                        actionType: "Close",
                        assetTypeId: +importJob.assetTypeId.id
                    })
                }} color="red">Close</PrimaryButton>
            }
            {
                Can(UserEntitlementCatalogs.ReprocessJobAssets) &&
                !isClosed(importJob.statusId) &&
                <Tooltip title={!canReprocess(importJob.statusId) ? <span style={{ fontSize: "12px" }}>Manual jobs or jobs that take less than 30 minutes are not processed</span> : ""}>
                    <ButtonTooltipBlock>
                        <Button
                            color="primary"
                            disabled={!canReprocess(importJob.statusId)}
                            onClick={(e) => {
                                preventDefaultAndStopPropagation(e);
                                $doProcessJob.set({
                                    jobId: importJob.jobId,
                                    needApproval: importJob.statusId.name === ImportJobStatusType.Processed,
                                    actionType: "Reprocess",
                                    assetTypeId: +importJob.assetTypeId.id
                                })
                            }}
                        >
                            Reprocess
                        </Button>
                    </ButtonTooltipBlock>
                </Tooltip>
            }
            {
                Can(UserEntitlementCatalogs.DeleteJobAssets) &&
                isProcessed(importJob.statusId) &&
                <Button
                    color="primary"
                    disabled={importJob.assetCount === importJob.digitizedAssetCount}
                    onClick={(e) => {
                        preventDefaultAndStopPropagation(e);
                        $doProcessJob.set({
                            jobId: importJob.jobId,
                            needApproval: true,
                            actionType: "Delete Assets",
                            assetTypeId: +importJob.assetTypeId.id
                        })
                    }}
                >
                    Delete Assets
                </Button>
            }
        </ButtonsBlock>
    </>
}

const ButtonTooltipBlock = span({
});

const ButtonsBlock = div({
    display: 'flex',
    flexDirection: 'row',
    padding: '12px 0px',
    justifyContent: 'right'
});
